import { Controller, useFormContext } from "react-hook-form";
import InlineContainer from "../../../common/InlineContainer";
import EditorInput from "../EditorInput";

export type RewardTiers = {
  low?: number;
  medium?: number;
  high?: number;
  critical?: number;
};

const RewardInput = ({
  label,
  value,
  className,
  onChange
}: {
  value: string;
  label: string;
  className?: string;
  onChange: (value: string) => void;
}) => (
  <div
    className={"overflow-hidden border-[1px] border-ctb-blue-50 " + className}
  >
    <p className="border-b border-ctb-blue-50 py-3 text-center font-semibold leading-[130%] text-ctb-blue-50">
      {label}
    </p>
    <input
      type="text"
      value={"$" + value}
      onChange={e => onChange(e.target.value)}
      className="relative z-0 w-full px-4 py-2 text-center focus:z-20 active:z-20"
    />
  </div>
);

const RewardInputs = ({
  value,
  onChange
}: {
  value?: RewardTiers;
  onChange: (value: RewardTiers) => void;
}) => {
  const handleChange = (key: keyof RewardTiers, val?: string) => {
    const num = val ? parseInt(val.replace("$", "")) : undefined;

    onChange({
      ...value,
      [key]: num === undefined ? undefined : isNaN(num) ? undefined : num
    });
  };

  return (
    <InlineContainer className="relative">
      <RewardInput
        label="Low"
        value={value?.low?.toString() || ""}
        onChange={low => handleChange("low", low)}
      />
      <RewardInput
        label="Medium"
        value={value?.medium?.toString() || ""}
        onChange={medium => handleChange("medium", medium)}
      />
      <RewardInput
        label="High"
        value={value?.high?.toString() || ""}
        onChange={high => handleChange("high", high)}
      />
      <RewardInput
        label="Critical"
        value={value?.critical?.toString() || ""}
        onChange={critical =>
          handleChange("critical", critical === "" ? undefined : critical)
        }
      />
    </InlineContainer>
  );
};

const ProgramRewardsInput = ({
  name,
  inputTitle: title,
  required
}: {
  name: string;
  inputTitle: string;
  required?: boolean;
}) => {
  const { control } = useFormContext();

  return (
    <EditorInput
      name={name}
      inputTitle={title}
      details="Outline the reward distribution (NZD) across the various report severity levels."
      required
    >
      <Controller
        name={name}
        control={control}
        rules={{
          required,
          validate: (value: RewardTiers) => {
            return (
              value.low !== undefined &&
              value.medium !== undefined &&
              value.high !== undefined &&
              value.critical !== undefined
            );
          }
        }}
        render={({ field: { value, onChange } }) => (
          <RewardInputs value={value} onChange={onChange} />
        )}
      />
    </EditorInput>
  );
};

export default ProgramRewardsInput;
